import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import i18n from './i18n'
import { autoMigrateOnStartup } from './services/idb-migration.service'
import { initSentry } from './services/sentry'
import { offlineQueue } from './services/sw-strategies'
import { autoAdvanceStage, isUserInV19, getStageStats } from './services/canary'
import { initDb } from './services/db.service'
import './styles/critical.css'
import './styles/tailwind.css'

const app = createApp(App)
const pinia = createPinia()

// Sentry init (生产环境真上报 · v19 服务化包装)
if (import.meta.env.PROD) {
  initSentry(app, router)
}

app.use(pinia)
app.use(router)
app.use(i18n)

// 离线队列自动 flush (网络恢复时)
offlineQueue.installAutoFlush()

// Canary 灰度自动推进 (按日期 5/21 5% → 5/26 25% → 6/1 50% → 6/16 100%)
const canaryCfg = autoAdvanceStage()
const stats = getStageStats()
console.info('[v19 Canary]', canaryCfg.stage, `${canaryCfg.rollout_pct}%`, `预估 v19 用户: ${stats.estimated_v19_users}/175`)

// 暴露给业务 (灯塔角色判断)
;(window as any).tnIsUserInV19 = isUserInV19

// 初始化 sql.js + IDB (业务页用)
initDb().then(() => console.info('[v19 DB] sql.js + IDB ready')).catch(err => {
  console.warn('[v19 DB] init failed (业务页 fallback mock)', err)
})

// Workbox SW 注册由 vite-plugin-pwa autoUpdate 处理
// 自定义策略在 sw-strategies.ts 暴露 (供更精细控制场景使用)

// 启动前自动迁移 v18 IDB → v19 (仅首次)
autoMigrateOnStartup().catch(err => {
  console.warn('[v19 startup] IDB migration error (non-blocking)', err)
}).finally(() => {
  app.mount('#app')
  console.info('[v19.0-Y] Trungnam MES Standard Edition · ready', {
    version: import.meta.env.VITE_VERSION,
    env: import.meta.env.MODE,
  })
})
